<header class="flex justify-between items-center px-6 h-16">
  <div class="text-primary flex gap-2 items-center">
    <img src="assets/icon/codijobs.png" class="h-10 w-10" alt="" />
    <div class="font-bold text-xl">Codijobs</div>
  </div>
  <div class="flex items-center space-x-6 text-[#BFBCC7]">
    <div class="flex items-center space-x-2 text-dark">
      <ng-icon name="ionPersonOutline"></ng-icon>
      <span>Admin</span>
    </div>
    <div class="h-6 border-l border-gray-300"></div>
    <button
      (click)="openConfirmLogout()"
      class="flex items-center space-x-2 hover:text-primary cursor-pointer"
    >
      <ng-icon name="ionLogOutOutline" size="20"></ng-icon>
      <span class="">Cerrar sesión</span>
    </button>
  </div>
</header>
<div
  *ngIf="confirmLogoutOpen"
  class="fixed inset-0 bg-black/60 flex items-center justify-center z-50"
>
  <div class="bg-white rounded-lg shadow-lg max-w-sm w-full p-6 text-center">
    <h2 class="text-lg font-semibold text-gray-800 mb-4">
      ¿Estás seguro que deseas cerrar sesión?
    </h2>
    <div class="flex justify-center gap-4">
      <button
        (click)="closeConfirmLogout()"
        class="px-4 py-2 rounded-md border border-gray-300 text-gray-700 hover:bg-gray-100 transition"
      >
        Cancelar
      </button>
      <app-loading-button
        [text]="'Cerrar sesión'"
        [loading]="loadingLogout"
        type="button"
        (click)="confirmLogout()"
      >
      </app-loading-button>
    </div>
  </div>
</div>
